import { CURRENT_PATH } from "../constants/header";
// import axios from "axios";

export const SetCurrentPath = (values) => async (dispatch) => {
  dispatch({ type: CURRENT_PATH, payload: values });
};
